import React from "react";
import PropTypes from "prop-types";
import Checkbox from "components/v2/form-elements/Checkbox";
import isTerminalSubscriber from "utils/isTerminalSubscriber";
import styles from "./styles.module.scss";

const MarketingOptInCheckbox = ({ country, onMarketingOptInChange, isChecked }) => {
    if (country === "US" || isTerminalSubscriber()) {
        return null;
    }

    return (
        <Checkbox
            className={ styles.newsletterMarketingCheckbox }
            checked={ isChecked }
            name="marketing-checkbox"
            onChange={ onMarketingOptInChange }
        >
            <span>Bloomberg may send me offers and promotions.</span>
        </Checkbox>
    );
};

MarketingOptInCheckbox.propTypes = {
    country: PropTypes.string.isRequired,
    onMarketingOptInChange: PropTypes.func.isRequired,
    isChecked: PropTypes.bool.isRequired
};

export default MarketingOptInCheckbox;
